(() => {
  if (window.__zaytounaGiftOptionsBound) return;
  window.__zaytounaGiftOptionsBound = true;

  const getRoot = (target) => target instanceof Element ? target.closest('[data-zaytouna-gift-options]') : null;

  const valuesFor = (root) => {
    const toggle = root.querySelector('[data-zgift-toggle]');
    const recipient = root.querySelector('[data-zgift-recipient]');
    const sender = root.querySelector('[data-zgift-sender]');
    const message = root.querySelector('[data-zgift-message]');
    const noInvoice = root.querySelector('[data-zgift-noinvoice]');
    const enabled = Boolean(toggle?.checked);

    return {
      'Zaytouna Gift': enabled ? 'Yes' : 'No',
      'Gift Recipient': enabled ? String(recipient?.value || '').trim() : '',
      'Gift Sender': enabled ? String(sender?.value || '').trim() : '',
      'Gift Message': enabled ? String(message?.value || '').trim() : '',
      'No Invoice': enabled && noInvoice?.checked ? 'Yes' : 'No'
    };
  };

  const setStatus = (root, text, isError = false) => {
    const status = root.querySelector('[data-zgift-status]');
    if (!status) return;
    status.textContent = text;
    status.style.color = isError ? '#b5432d' : '';
  };

  const saveNow = async (root) => {
    if (!root) return;
    const isArabic = document.documentElement.lang?.toLowerCase().startsWith('ar');
    setStatus(root, isArabic ? 'جاري حفظ تفاصيل الهدية…' : 'Saving gift details…');

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ attributes: valuesFor(root) })
      });
      if (!response.ok) throw new Error('gift_update_failed');
      setStatus(root, isArabic ? 'تم حفظ تفاصيل الهدية ✓' : 'Gift details saved ✓');
    } catch (error) {
      setStatus(root, isArabic ? 'تعذر حفظ تفاصيل الهدية الآن' : 'Could not save gift details', true);
    }
  };

  const timers = new WeakMap();
  const scheduleSave = (root, delay = 250) => {
    if (!root) return;
    const previous = timers.get(root);
    if (previous) clearTimeout(previous);
    const timer = setTimeout(() => {
      timers.delete(root);
      saveNow(root);
    }, delay);
    timers.set(root, timer);
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    const root = getRoot(target);
    if (!root) return;

    if (target.matches('[data-zgift-toggle], [data-zgift-noinvoice]')) {
      scheduleSave(root, 0);
      return;
    }

    if (target.matches('[data-zgift-recipient], [data-zgift-sender], [data-zgift-message]')) {
      scheduleSave(root, 0);
    }
  }, true);

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.matches('[data-zgift-recipient], [data-zgift-sender], [data-zgift-message]')) return;
    scheduleSave(getRoot(target), 300);
  }, true);
})();